import React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import StyledSelect from "~styled/select/StyledSelect";

interface PhoneTipoSelectorProps {
  value: boolean;
  onChange?: (event: any) => void;
}

const PhoneTipoSelector: React.FC<PhoneTipoSelectorProps> = ({
  value,
  onChange,
}) => {
  // `key` es una prop reservada de React y nunca llega al componente, así que el
  // identificador siempre fue el mismo. Se conserva tal cual para no cambiar el DOM.
  const labelId = "moneda-label-0";

  return (
    <FormControl>
      <InputLabel
        sx={{
          transform: "translate(0, 12px) scale(1)",
          transformOrigin: "top left",
          "&.MuiInputLabel-shrink": {
            transform: "translate(0, -1px) scale(0.75)",
          },
        }}
        id={labelId}
      >
        TIPO
      </InputLabel>
      <StyledSelect
        variant="standard"
        labelId={labelId}
        value={value}
        style={{ minWidth: 81, alignContent: "start" }}
        onChange={onChange}
      >
        <MenuItem value={true as any}>MÓVIL</MenuItem>
        <MenuItem value={false as any}>FIJO</MenuItem>
      </StyledSelect>
    </FormControl>
  );
};

export default PhoneTipoSelector;
